import React from 'react'
import './footer.css'
import Logo from '../../assets/logowhite.png'
import { Link } from 'react-router-dom'
import { FOOTER_ABOUT_BLURB, TAGLINE } from '../../constants/brand'

/**
 * @param {{ edgeAware?: boolean }} props — set on pages with a fixed left widget (e.g. visit counter) so footer copy doesn’t sit under it
 */
const Footer = ({ edgeAware = false }) => {
  return (
    <footer
      className={`footer${edgeAware ? ' footer--edge-aware' : ''}`}
      role="contentinfo"
    >
      <div className="footer__inner">
        <div className="footer__brand">
          <Link to="/" className="footer__brand-link" aria-label="Luxistt home">
            <img className="footer__logo" src={Logo} alt="" />
          </Link>
          <p className="footer__micro">{TAGLINE}</p>
        </div>

        <nav className="footer__col footer__col--explore" aria-label="Site links">
          <p className="footer__label">Explore</p>
          <ul className="footer__list">
            <li>
              <Link to="/">Home</Link>
            </li>
            <li>
              <Link to="/rooms">Apartments</Link>
            </li>
            <li>
              <Link to="/terms">Terms</Link>
            </li>
            <li>
              <Link to="/contact-us">Contact</Link>
            </li>
          </ul>
        </nav>

        <nav className="footer__col footer__col--account" aria-label="Account">
          <p className="footer__label">Account</p>
          <ul className="footer__list">
            <li>
              <Link to="/login">Log in</Link>
            </li>
            <li>
              <Link to="/signup">Create account</Link>
            </li>
          </ul>
        </nav>

        <div className="footer__about">
          <p className="footer__label">Why Luxistt</p>
          <p className="footer__blurb">{FOOTER_ABOUT_BLURB}</p>
        </div>
      </div>

      <div className="footer__legal">
        <span className="footer__copy">
          &copy; {new Date().getFullYear()} Luxistt. All rights reserved.
        </span>
        <span className="footer__social">
          Follow us:
          {' '}
          <a
            href="https://www.instagram.com/luxisttapartment?igsh=bG1vc2k5bDljNXlj&utm_source=qr"
            target="_blank"
            rel="noopener noreferrer"
            className="footer__social-link"
          >
            Instagram
          </a>
          {' '}·{' '}
          <a
            href="https://web.facebook.com/profile.php?id=61588321945450"
            target="_blank"
            rel="noopener noreferrer"
            className="footer__social-link"
          >
            Facebook
          </a>
        </span>
        <span className="footer__credit">
          Built with <span className="footer__heart" aria-label="love">&#10084;</span> by{' '}
          <a
            href="https://www.newistt.com"
            target="_blank"
            rel="noopener noreferrer"
            className="footer__credit-link"
          >
            newistt
          </a>
        </span>
      </div>
    </footer>
  )
}

export default Footer
